// extracted by mini-css-extract-plugin
export default {"body":"TooltipBody_body__mDCo5"};